import React from 'react';
import { TextField } from '@mui/material';

interface MarkdownEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  height?: number;
}

const MarkdownEditor: React.FC<MarkdownEditorProps> = ({ 
  value, 
  onChange, 
  placeholder,
  height = 200 
}) => {
  return (
    <TextField
      multiline
      rows={Math.floor(height / 25)}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      fullWidth
      variant="outlined"
      helperText="Markdown supported"
    />
  );
};

export default MarkdownEditor;